<div class="metadata-dialog" style="width: 30vw; min-width: 400px;">
    <h2 mat-dialog-title>
        Configure {{chartName}} Chart
    </h2>

    <mat-dialog-content style="padding-top: 20px;">
        @if (!isLoaded) {
        <busy-indicator></busy-indicator>
        }
        <form name="chartSettingsForm">
            @if (isLoaded) {
            <metadata-panel ngModelGroup="gridFilter" [metadata]="metadata" [model]="model">
            </metadata-panel>
            }
        </form>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <forge-button variant="outlined" (click)="saveDefaults()" telemetry="Submission-ChartSaveDefaults">Save
            Defaults</forge-button>
        <forge-button variant="outlined" (click)="clearDefaults()" telemetry="Submission-ChartClearDefaults">Clear
            Defaults</forge-button>
        <forge-button variant="raised" (click)="done()" telemetry="Submission-ChartDone">Done</forge-button>
    </mat-dialog-actions>
</div>